import { Container, Sprite } from 'pixi.js'
import { dimensions } from '../../config/settings'

export function createFrameOverlay(): Container {
  const container = new Container()
  container.eventMode = 'none'
  container.interactiveChildren = false

  const frame = Sprite.from('ramecek')
  frame.eventMode = 'none'
  frame.width = dimensions.MAX_WIDTH
  frame.height = dimensions.MAX_HEIGHT
  frame.x = 0
  frame.y = 0

  container.addChild(frame)
  return container
}

